// src/pages/FaqPublicResults/components/HelpAccordion.jsx
import React from "react";
import { FaChevronDown, FaExclamationTriangle } from "react-icons/fa";

export default function HelpAccordion({
  section,
  isOpen,
  onToggle,
  sectionRef,
}) {
  return (
    <article
      ref={sectionRef}
      className="scroll-mt-28 overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900"
    >
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-start justify-between gap-4 p-4 text-left transition hover:bg-slate-50 dark:hover:bg-slate-800/50 sm:p-5"
      >
        <div className="flex min-w-0 items-start gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-indigo-50 text-2xl dark:bg-indigo-950/70">
            {section.icon}
          </div>

          <div className="min-w-0">
            <div className="text-xs font-bold uppercase tracking-wide text-indigo-600 dark:text-indigo-300">
              {section.eyebrow}
            </div>

            <h2 className="mt-1 text-lg font-bold text-slate-900 dark:text-white sm:text-xl">
              {section.title}
            </h2>

            <p className="mt-1 text-sm leading-relaxed text-slate-500 dark:text-slate-400">
              {section.summary}
            </p>
          </div>
        </div>

        <div
          className={`mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-slate-100 text-slate-600 transition dark:bg-slate-800 dark:text-slate-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <FaChevronDown />
        </div>
      </button>

      <div
        className={`grid transition-all duration-300 ${
          isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <div className="border-t border-slate-200 p-4 dark:border-slate-800 sm:p-5">
            <div className="grid grid-cols-1 gap-4">
              {section.blocks.map((block, index) => (
                <HelpBlock key={`${section.id}-${index}`} block={block} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

function HelpBlock({ block }) {
  return (
    <section className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/50">
      <h3 className="text-base font-bold text-slate-900 dark:text-white">
        {block.title}
      </h3>

      <ul className="mt-3 space-y-2">
        {block.items.map((item, index) => (
          <li
            key={`${block.title}-${index}`}
            className="flex gap-2 text-sm leading-relaxed text-slate-700 dark:text-slate-200"
          >
            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-indigo-500" />
            <span>{item}</span>
          </li>
        ))}
      </ul>

      {block.warning ? (
        <div className="mt-4 flex gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-3 text-sm font-semibold text-amber-800 dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-300">
          <FaExclamationTriangle className="mt-0.5 shrink-0" />
          <span>{block.warning}</span>
        </div>
      ) : null}
    </section>
  );
}